import { Component, Input } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SideNavService } from 'src/app/core-flc/sidenav/sidenav.service';
import { StressAreaGroupDto } from 'src/app/server-api/models';
import { StressAreaGroupControllerService } from 'src/app/server-api/services';
import { DetailComponent } from 'src/app/utils-flc/detail/detail.component';
import { IStressGroupFormGroup } from './IStressGroupFormGroup';

@Component({
  selector: 'app-stress-group',
  templateUrl: './stress-group.component.html',
  styleUrls: ['./stress-group.component.css']
})
export class StressGroupComponent extends DetailComponent {
  group: StressAreaGroupDto;

  //override the id coming from route params by id coming from dialog
  @Input() override id: string;

  constructor(
    public override translate: TranslateService,
    private groupService: StressAreaGroupControllerService,
    public override sidenavService: SideNavService,
    public override router: Router,
    private formBuilder: UntypedFormBuilder
  ) {
    super(translate, sidenavService, router);
  }

  override initItem(): void {
    super.initItem();
    //init an empty dto and set the invisible fields
    this.group = {} as any as StressAreaGroupDto;

    this.initForm();
    this.columnsVisible.set('id', false);
  }

  override getItem(request) {
    super.getItem(request);

   console.log("stress area id to pick up " + this.id);
   this.groupService.getStressAreaGroup(request).subscribe((data: StressAreaGroupDto) => {
      this.group = data;
      this.name = data.id;

      //to fix to many digits from server sometimes
      this.group.maxDepthSoil = Math.round(this.group.maxDepthSoil * 1000) / 1000;
      this.group.minDepthSoil = Math.round(this.group.minDepthSoil * 1000) / 1000;
      this.group.maxGravelThickness = Math.round(this.group.maxGravelThickness * 1000) / 1000;
      this.group.minGravelThickness = Math.round(this.group.minGravelThickness * 1000) / 1000;
      this.group.longHardCenterErrorPerc = Math.round(this.group.longHardCenterErrorPerc * 1000) / 1000;
      this.group.longHardEdgeErrorPerc = Math.round(this.group.longHardEdgeErrorPerc * 1000) / 1000;
      this.group.longOverallErrorPerc = Math.round(this.group.longOverallErrorPerc * 1000) / 1000;
      this.group.longTwistErrorPerc = Math.round(this.group.longTwistErrorPerc * 1000) / 1000;

      this.initForm();
      this.detailForm.controls['id'].disable();

    });
  }

  override setForm() {
    //set visibility fields, set FormGroup and validators
    super.setForm();

    this.columnsVisible = new Map([
      ['id', false],
      ['created', true],
      ['lastModificationDate', true],
      ['calcStatus', true],
      ['groupType', true],
      ['maxDepthSoil', true],
      ['minDepthSoil', true],
      ['maxGravelThickness', true],
      ['minGravelThickness', true],
      ['stressPatternAvg', true],
      ['surface', true],
      ['tunnelSection', true],
      ['longHardCenterErrorPerc', true],
      ['longHardEdgeErrorPerc', true],
      ['longOverallErrorPerc', true],
      ['longTwistErrorPerc', true]
      ]);

    this.detailForm = this.formBuilder.group({
      id: [{ value: '', disabled: true }],
      created: [{ value: '', disabled: true }],
      lastModificationDate: [{ value: '', disabled: true }],
      calcStatus: [{ value: '', disabled: true }],
      groupType: [{ value: '', disabled: true }],
      maxDepthSoil: [{ value: '', disabled: true }],
      minDepthSoil: [{ value: '', disabled: true }],
      maxGravelThickness: [{ value: '', disabled: true }],
      minGravelThickness: [{ value: '', disabled: true }],
      stressPatternAvg: [{ value: 0, disabled: true }],
      tunnelSection: [{ value: '', disabled: true }],
      surface: [{ value: '', disabled: true }],
      longHardCenterErrorPerc: [{ value: 0, disabled: true}],
      longHardEdgeErrorPerc: [{ value: 0, disabled: true}],
      longOverallErrorPerc: [{ value: 0, disabled: true}],
      longTwistErrorPerc: [{ value: 0, disabled: true}],
      }) as IStressGroupFormGroup;

    //patch value dto to formGroup
    this.detailForm.patchValue(this.group);
  }

  override initForm() {
    super.initForm();
    this.initDialogDelete('stress-group.dialog_title');

    //set topmenu icon actions
    this.translate.get(['icon_refresh', 'icon_menu']).subscribe((translations: string) => {
      this.topMenuIcons = [
        {
          icon: 'refresh',
          title: translations['icon_refresh'],
          routerLink: null,
          clickMethod: 'refresh',
        }
      ];
    });
    this.setForm();
  }


  override saveOk() {
    super.saveOk();
    this.sidenavService.setLoading(false);
    //no save done
  }


  override delete() {
    super.delete();
    this.sidenavService.setLoading(false);
    //no delete done
  }

  getMaxPerc()
  {
    if (this.group)
    {
      let max = Math.max(this.group.longHardCenterErrorPerc, this.group.longHardEdgeErrorPerc, this.group.longOverallErrorPerc,   this.group.longTwistErrorPerc);
      return Math.round(max * 1000) / 1000;
    }
    return 0;
  }
}


